// Configuração do site - PRF Tubulações de Gás
export const siteConfig = {
  nomeEmpresa: "PRF Tubulações de Gás",
  slogan: "Segurança, precisão e excelência em tubulações de gás.",
  descricao: "Especialistas em instalação, manutenção e adequação de tubulações de gás. Atendemos residências, comércios e indústrias no Rio de Janeiro.",
  
  // Contato
  telefone: "(21) 99032-3790",
  telefoneWhatsApp: "5521990323790",
  email: "atendimento@prfgas.com",
  
  // Endereço
  endereco: "Av. Maracanã, 39 - Tijuca, Rio de Janeiro - RJ",
  cidade: "Rio de Janeiro",
  estado: "RJ",
  regioesAtendidas: ["Zona Sul", "Zona Norte", "Zona Oeste", "Centro", "Niterói", "Baixada Fluminense"],
  
  // Horário
  horario: "Seg - Sex: 08h às 17h",
  
  // Links
  linkWhatsApp: "https://wa.me/5521990323790?text=Olá! Gostaria de solicitar um orçamento.",
};

// Diferenciais
export const diferenciais = [
  {
    titulo: "Segurança em Primeiro Lugar",
    descricao: "Seguimos rigorosamente as normas ABNT e procedimentos de segurança.",
    icone: "Shield",
  },
  {
    titulo: "Equipe Qualificada",
    descricao: "Técnicos certificados e com vasta experiência no mercado.",
    icone: "Users",
  },
  {
    titulo: "Materiais Certificados",
    descricao: "Utilizamos apenas materiais de qualidade com certificação.",
    icone: "BadgeCheck",
  },
  {
    titulo: "Prazo e Transparência",
    descricao: "Cumprimos prazos e mantemos você informado em cada etapa.",
    icone: "Clock",
  },
  {
    titulo: "Garantia de Serviço",
    descricao: "Oferecemos garantia em todos os nossos serviços realizados.",
    icone: "Award",
  },
  {
    titulo: "Atendimento via WhatsApp",
    descricao: "Comunicação rápida e prática pelo seu aplicativo favorito.",
    icone: "MessageCircle",
  },
];

// Processo de trabalho
export const processo = [
  {
    numero: "01",
    titulo: "Visita Técnica",
    descricao: "Realizamos uma visita para diagnóstico completo e elaboração do orçamento detalhado.",
  },
  {
    numero: "02",
    titulo: "Execução Segura",
    descricao: "Executamos o serviço com total segurança, seguindo normas técnicas e realizando testes.",
  },
  {
    numero: "03",
    titulo: "Entrega e Orientação",
    descricao: "Entregamos o serviço com documentação completa e orientações de uso e manutenção.",
  },
];

// FAQ
export const faq = [
  {
    pergunta: "Vocês fazem teste de estanqueidade?",
    resposta: "Sim! Realizamos testes de estanqueidade com equipamentos de alta precisão, seguindo todas as normas técnicas. Após o teste, emitimos laudo técnico completo.",
  },
  {
    pergunta: "Trabalham com GN e GLP?",
    resposta: "Sim, trabalhamos com instalações para gás natural (GN) e gás liquefeito de petróleo (GLP). Nossa equipe é especializada em ambos os tipos de instalação.",
  },
  {
    pergunta: "Qual o prazo médio para instalação?",
    resposta: "O prazo varia conforme a complexidade do serviço. Instalações simples podem ser concluídas em 1-2 dias. Projetos maiores são avaliados individualmente na visita técnica.",
  },
  {
    pergunta: "Emitem laudo e ART?",
    resposta: "Sim, emitimos todos os documentos técnicos necessários, incluindo laudo de estanqueidade, ART (Anotação de Responsabilidade Técnica) e documentação para concessionárias.",
  },
  {
    pergunta: "Atendem emergências?",
    resposta: "Sim! Em casos de vazamento ou emergências, oferecemos atendimento prioritário. Entre em contato pelo WhatsApp para atendimento imediato.",
  },
  {
    pergunta: "Como funciona o orçamento?",
    resposta: "Entre em contato pelo WhatsApp ou formulário. Agendamos uma visita técnica gratuita para avaliar o local e elaborar um orçamento detalhado sem compromisso.",
  },
  {
    pergunta: "Quais regiões vocês atendem?",
    resposta: "Atendemos toda a região metropolitana do Rio de Janeiro, incluindo Zona Sul, Zona Norte, Zona Oeste, Centro, Niterói e Baixada Fluminense.",
  },
  {
    pergunta: "Vocês oferecem garantia?",
    resposta: "Sim! Todos os nossos serviços possuem garantia. O prazo varia conforme o tipo de serviço realizado. Consulte-nos para mais detalhes.",
  },
];
